module.exports = "/_next/static/images/apple-icon-152x152-6d742e7d1a2c60360cd529cbc1544502.png";